<template>
  <div>DesempenhoPorEquipe</div>
</template>

<script>
export default {}
</script>

<style></style>
